"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", [_c("html", [_c("head"), _c("body", [_c("h1", [_vm._v("VirtualScrollListToSelect 虚拟滚动列表选择组件（支持多选、单选）")]), _c("ul", [_c("li", [_vm._v("使用该组件需要安装 "), _c("code", {
    pre: true
  }, [_vm._v("vue-virtual-scroller")]), _vm._v(" 依赖， "), _c("code", {
    pre: true
  }, [_vm._v("yarn add vue-virtual-scroller")])])]), _c("h2", [_vm._v("何时使用")]), _c("p", [_vm._v("一次性加载的长列表单选或多选时使用。如“店铺列表选择”、“用户列表选择”等业务场景。")]), _c("p", [_vm._v("通过虚拟滚动列表解决页面长列表卡顿问题。")])])])]);
}];
render._withStripped = true;